module.exports = __webpack_public_path__ + "static/media/trash_white.81c84112.svg";